import { instance } from "libs/api";

import { ApiRoutesDeliveryCompanies } from "../../constants";

export const requestDeleteDeliveryCompany = async (
  companyId: string
): Promise<void> => {
  return await instance.delete(
    `${ApiRoutesDeliveryCompanies.Companies}/${companyId}`
  );
};
